import { Flex } from 'foundations-components/components/Flex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CampaignOptionLabel({
  text = '',
  color,
  truncate
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    "data-test-id": `select-dropdown-option-${text}`,
    alignItems: "center",
    gap: '200',
    children: [color && /*#__PURE__*/_jsx("div", {
      style: {
        backgroundColor: color,
        width: 8,
        height: 8,
        borderRadius: '50%',
        flexShrink: 0
      }
    }), truncate ? /*#__PURE__*/_jsx(TruncateString, {
      maxWidth: 300,
      children: text
    }) : text]
  });
}